export default {
    parts: ['control', 'label'],
    baseStyle: {
        control: {
            borderColor: 'gray.500',
            _invalid: {
                border: 'red.500',
            },
            _checked: {
                borderColor: 'blue.400',
                background: 'blue.400',
            },
        },
        label: {
            _invalid: {
                color: 'red.500',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2tib3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9hcGV4LW9ubGluZS9jb21wb25lbnQtbGlicmFyeS90aGVtZS9jb21wb25lbnRzL2NoZWNrYm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixLQUFLLEVBQUUsQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDO0lBQzNCLFNBQVMsRUFBRTtRQUNULE9BQU8sRUFBRTtZQUNQLFdBQVcsRUFBRSxVQUFVO1lBQ3ZCLFFBQVEsRUFBRTtnQkFDUixNQUFNLEVBQUUsU0FBUzthQUNsQjtZQUNELFFBQVEsRUFBRTtnQkFDUixXQUFXLEVBQUUsVUFBVTtnQkFDdkIsVUFBVSxFQUFFLFVBQVU7YUFDdkI7U0FDRjtRQUNELEtBQUssRUFBRTtZQUNMLFFBQVEsRUFBRTtnQkFDUixLQUFLLEVBQUUsU0FBUzthQUNqQjtTQUNGO0tBQ0Y7Q0FDRixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBwYXJ0czogWydjb250cm9sJywgJ2xhYmVsJ10sXG4gIGJhc2VTdHlsZToge1xuICAgIGNvbnRyb2w6IHtcbiAgICAgIGJvcmRlckNvbG9yOiAnZ3JheS41MDAnLFxuICAgICAgX2ludmFsaWQ6IHtcbiAgICAgICAgYm9yZGVyOiAncmVkLjUwMCcsXG4gICAgICB9LFxuICAgICAgX2NoZWNrZWQ6IHtcbiAgICAgICAgYm9yZGVyQ29sb3I6ICdibHVlLjQwMCcsXG4gICAgICAgIGJhY2tncm91bmQ6ICdibHVlLjQwMCcsXG4gICAgICB9LFxuICAgIH0sXG4gICAgbGFiZWw6IHtcbiAgICAgIF9pbnZhbGlkOiB7XG4gICAgICAgIGNvbG9yOiAncmVkLjUwMCcsXG4gICAgICB9LFxuICAgIH0sXG4gIH0sXG59XG4iXX0=